import { render, staticRenderFns } from "./durationLists.vue?vue&type=template&id=31399b54"
import script from "./durationLists.vue?vue&type=script&lang=js"
export * from "./durationLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports